import Vue from 'vue';
// eslint-disable-next-line import/no-cycle
import feathersClient from '../../feathers-client';

const defaultSyncUserHistoryPagination = {
	total: 100,
	$skip: 0,
	$limit: 6,
};
const defaultSyncUserHistoryFilter = {
	$skip: defaultSyncUserHistoryPagination.$skip,
	$limit: defaultSyncUserHistoryPagination.$limit,
};
export default {
	state: {
		syncUserHistory: [],
		syncUserHistoryPagination: defaultSyncUserHistoryPagination,
		SyncUserHistoryFilter: defaultSyncUserHistoryFilter,
	},
	getters: {
		setsyncUserHistoryPage: (state) => {
			const { $limit, $skip } = state.syncUserHistoryPagination;
			return $skip / $limit + 1;
		},
	},
	mutations: {
		SET_SYNC_USER_HISTORY: (state, data) => { state.syncUserHistory = data; },
		SET_SYNC_USER_HISTORY_PAGINATION: (state, data) => { state.syncUserHistoryPagination = {...state.syncUserHistoryPagination, ...data};},
		SET_SYNC_USER_HISTORY_FILTER: (state, filter) => { state.SyncUserHistoryFilter = { ...state.SyncUserHistoryFilter, ...filter }; },
		SET_SYNC_USER_HISTORY_PERMISSION: (state, syncUserHistoryPermission) => { state.syncUserHistoryPermission = syncUserHistoryPermission; },
	},
	actions: {
		setSyncUserHistoryFilter: ({ commit }, filter) => {
			commit('SET_SYNC_USER_HISTORY_FILTER', filter);
		},
		setsyncUserHistoryListPage: ({ commit, state }, page) => {
			const $skip = (page - 1) * state.syncUserHistoryPagination.$limit;
			commit('SET_SYNC_USER_HISTORY_PAGINATION', { $skip });
			commit('SET_SYNC_USER_HISTORY_FILTER', { $skip });
		},
		getAllSyncUserHistoryForTrust: async({ rootGetters, commit }, filter) => {
			const results = await feathersClient.service('api/v3/sync-user-to-optima-history').find({
				query: {
					// $role: rootGetters.currentUserRole,
					$sort: { createdAt: -1 },
					...filter,

				},
			});
			commit('SET_SYNC_USER_HISTORY', results.data);
			commit('SET_SYNC_USER_HISTORY_PAGINATION', { total: results.total });
			return results.data;
		},
		updateSyncUserHistoryForTrust: async({ rootGetters, commit }, data) => {
			const results = await feathersClient.service('/api/v3/sync-user-to-optima-history').patch(data.id, data, {
				// query:{
				// 	$role: rootGetters.currentUserRole,
				// }
			});
			return results;
		},
	},
};
